import { useEffect, useState } from 'react';
import { Props, SBankDetails } from './types';
import { CashAndBankBookService } from 'services/api';
import { Autocomplete, Box, createFilterOptions, TextField, Typography } from '@mui/material';
import Icon from 'components/FormControl/Icon';
import { ADD_NEW_BANK } from './constants';
import AddBankModal from 'pages/CashAndBankBook/components/AddBankModal';
import { useAppContext } from 'contexts/AppContext';
import { ApiError } from 'services/api/base';

const filter = createFilterOptions<SBankDetails>();

const BankDetails = (props: Props) => {
  const [bankDetails, setBankDetails] = useState<SBankDetails[]>([]);
  const [toggleOpen, setToggleOpen] = useState<boolean>(false);

  const { snack } = useAppContext();

  const fetchData = () =>
    CashAndBankBookService.getBankData()
      .then((response) => {
        const res = response.data.data.items;
        setBankDetails(res);
      })
      .catch((error) => {
        snack.show((error as ApiError).userMessage, 'error');
      });

  useEffect(() => {
    fetchData();
  }, []);

  const renderOption = (props: React.HTMLAttributes<HTMLLIElement>, option: SBankDetails) => {
    if (option.name === ADD_NEW_BANK) {
      return (
        <li key={option.id} {...props}>
          <div
            key={option.id}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '3px 0px',
              width: '100%',
            }}
          >
            <Typography
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#2e6acf',
              }}
              variant={'h5'}
            >
              <Icon icon='ri-add-line' size='1.2rem' />
              {ADD_NEW_BANK}
            </Typography>
          </div>
        </li>
      );
    } else
      return (
        <li key={option.id} {...props}>
          <Box display={'flex'} flexDirection={'row'} width={'100%'}>
            <Box display={'flex'} flexDirection={'column'} width={'100%'}>
              <Typography color={'text.primary'}>{option.name}</Typography>
              <Typography color={'text.secondary'} sx={{ textAlign: 'end' }}>
                {option.accountNo}
              </Typography>
            </Box>
          </Box>
        </li>
      );
  };

  return (
    <>
      <Autocomplete
        options={bankDetails}
        value={props.bankId ? bankDetails.find((bank) => bank.id === props.bankId) || null : null}
        onChange={(event, value) => {
          if (value?.name === ADD_NEW_BANK) {
            setToggleOpen(true);
          } else {
            props.onChange(value);
          }
        }}
        getOptionLabel={(option: SBankDetails) => `${option.name}-${option.accountNo}`}
        renderInput={(params) => (
          <TextField
            {...params}
            label={'Bank Detail'}
            variant='standard'
            error={props.error}
            required
          />
        )}
        renderOption={renderOption}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          filtered.push({
            id: '-',
            name: ADD_NEW_BANK,
            accountNo: '-',
          });
          return filtered;
        }}
      />
      {toggleOpen ? (
        <AddBankModal open={toggleOpen} onClose={() => setToggleOpen(false)} onSubmit={fetchData} />
      ) : null}
    </>
  );
};

export default BankDetails;
